export const ACTION_LOGS_BEGIN_DATE = new Date(2024, 11, 1);

export const toUTCISOString = (date: Date): string => date.toISOString();

export const parseDateFromURL = (date_string?: string | null) => {
  if (!date_string) return null;
  const [datePart, timePart] = date_string.split('T');
  if (!datePart || !timePart) return null;
  const [year, month, day] = datePart.split('-').map(Number);
  const [hours, minutes] = timePart.split(':').map(Number);

  return new Date(year, month - 1, day, hours, minutes);
};

export const formatForURL = (date?: Date | null) => {
  if (!date) return '';
  const pad = (n: number) => String(n).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
};

export const validateDates = (
  start: Date | string | null,
  end: Date | string | null
): string | null => {
  const startDate = start instanceof Date ? start : start ? new Date(start) : null;
  const endDate = end instanceof Date ? end : end ? new Date(end) : null;

  if (!startDate && !endDate) return 'Start and end dates must be selected.';
  if (!startDate) return 'Start date must be selected.';
  if (!endDate) return 'End date must be selected.';
  if (startDate && isNaN(startDate.getTime())) return 'Start date is invalid.';
  if (endDate && isNaN(endDate.getTime())) return 'End date is invalid.';

  if (startDate && startDate < ACTION_LOGS_BEGIN_DATE)
    return `Start date cannot be before ${ACTION_LOGS_BEGIN_DATE.toLocaleDateString()}.`;
  if (endDate && endDate < ACTION_LOGS_BEGIN_DATE)
    return `End date cannot be before ${ACTION_LOGS_BEGIN_DATE.toLocaleDateString()}.`;
  if (startDate && endDate && endDate < startDate) return 'End date cannot be before start date.';

  return null;
};
